export default __webpack_public_path__ + "static/comparisons-control-transparency-a10b6a885eea18ee6608ae5c3d94b9e0.webp";